import { Attribute, Component, Inject, Input, OnInit, Optional, REQUEST } from '@angular/core';
import { SsrService } from '@hrra/core';
import { ErrorTypeEnum } from '@hrra/ui';
import { LogginService } from '@hrra/core';
import pino from 'pino';

@Component({
  selector: 'app-not-existing-page',
  templateUrl: './not-existing-page.component.html',
  styleUrls: ['./not-existing-page.component.scss'],
  standalone: false
})
export class NotExistingPageComponent implements OnInit {

  _logger: pino.Logger;

  get logger() {
    return this._logger;
  }

  @Input() hideDefaultMessage: boolean;
  @Input() errorType: ErrorTypeEnum;

  constructor(private ssr: SsrService, @Inject(REQUEST) private request: Request, private logService: LogginService) {
    this.errorType = ErrorTypeEnum.NotFound;
    this._logger = this.logService.createLogger('not-existing-page-component');
  }

  ngOnInit(): void {

    if (this.errorType == ErrorTypeEnum.NotFound) {
      if (this.request !== null && this.request.url !== undefined) {
        this.logger.warn('Request url not found for : ' + this.request.url);
      }
      else {
        this.logger.error('Reqest is null, url not found');
      }
      
      this.ssr.setStatusNotFound();
    }
    else if (this.errorType == ErrorTypeEnum.NotAvailable) {
      this.ssr.setStatusNotAvailable();
    }
  }

}
